<template>
  <div id="staffProfile" class="container-fluid" :style= "[
      activeTab == 'schedule' ? {'margin-top': marginTop} : {'margin-top': '-50px'}
    ]">
    <div class="row">
      <div class="col-md-12">
        <h3 style="font-weight:700">Pengaturan Akun</h3>
      </div>
      <!-- sidebar menu -->
      <div class="col-md-2 no-padding pr-0">
        <div
          class="card card-box"
          style="border-radius : 0%; height: 100%; min-height: 650px;"
        >
          <div class="card-body">
            <div class="col-md-12 p-0 text-center">
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('profil_staff')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'profil_staff'
                      ? '__blue text-left'
                      : 'text-left'
                  "
                  >Profil Staff</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('profil_faskes')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'profil_faskes'
                      ? '__blue text-left'
                      : 'text-left'
                  "
                  >Tempat Praktik</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('schedule')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'schedule' ? '__blue text-left' : 'text-left'
                  "
                  >Jadwal & Fasilitas</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
            </div>
          </div>
        </div>
      </div>
      <!-- Profil Dokter -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'profil_staff'">
        <StaffFaskesProfile />
      </div>

      <!-- Profile Faskes -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'profil_faskes'">
        <FaskesProfile />
      </div>

      <!-- Profile Faskes -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'schedule'">
        <ScheduleFaskes />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { EventBus } from "../../../event-bus";
library.add(faInfo, faCamera, faFolder, faTimes);

export default {
  components: {
    StaffFaskesProfile: () => import("./ProfileComponent.vue"),
    FaskesProfile: () => import("./FaskesComponent.vue"),
    ScheduleFaskes: () => import("./ScheduleComponent.vue")
  },
  data() {
    return {
      activeTab: "profil_staff",
      marginTop: '-100px'
    };
  },
  created() {},
  mounted() {
    this.watchSchedule()
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  watch: {},
  methods: {
    selectTab(menu) {
      this.activeTab = menu;
    },
    getMarginTop(data) {
      try {
        let mt = '100px';
        this.marginTop = '-' + (parseInt(6 * data) + ((data == 0) ? 50 : 100)) + 'px'
        document.getElementById('staffProfile').style.height = this.marginTop
      return mt;
      } catch (error) {
        // console.log(error)
      }
    },
    watchSchedule() {
      EventBus.$on("count-schedule", val => {
        this.getMarginTop(val)
      });
    },
  }
};
</script>

<style scoped>
#staffProfile {
  transform: scale(0.78);
  width: 128%;
  margin-left: -14%;
  /* margin-top: -100px; */
  font-size: 12pt;
}

.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
</style>
